@if (displayToast()) {
  <div id="toast">
    <app-toast
      [toastStyle]="toastStyle()"
      [icon]="toastIcon()"
      [text]="toastMessage()"
    ></app-toast>
  </div>
}
<div id="title--container">
  <h4>All Users</h4>
  <h5>{{ laboratory?.laboratoryName }}</h5>
</div>
<hr />
<div id="users--container">
  @if (isFirstLoad()) {
    <div id="loading-spinner">
      <app-loading-spinner label="Fetching users"></app-loading-spinner>
    </div>
  }
  @if (!isFirstLoad() && loadError()) {
    <app-error-page primaryText="Failed to load users"></app-error-page>
  }
  @if (!isFirstLoad() && !loadError()) {
    <div id="inner-page--container">
      <div id="actions--container">
        <app-search-field
          [field]="searchField"
          [parentForm]="tableControls"
          (buttonClicked)="handleSearch($event)"
        ></app-search-field>
        @if (hasActiveFilters()) {
          <app-icon-button
            label="Clear Filters"
            buttonStyle="transparent--dark-blue"
            buttonId="clear-filters-btn"
            buttonShape="square"
            (buttonClicked)="clearFilters()"
          ></app-icon-button>
        }
        <app-icon-button
          label="filters"
          buttonStyle="secondary"
          buttonId="filter-btn"
          iconName="filter_list"
          buttonShape="square"
          (buttonClicked)="openModal('filter')"
          title="Filters"
        ></app-icon-button>
      </div>
      <div id="table--container">
        <table mat-table [dataSource]="users()">
          <caption class="sr-only">
            Users table
          </caption>
          <ng-container matColumnDef="firstName">
            <th
              mat-header-cell
              *matHeaderCellDef
              (click)="onSort('FirstName')"
              (keydown.enter)="onSort('FirstName')"
              (keydown.space)="$event.preventDefault(); onSort('FirstName')"
              [class.active]="currentSort().sortBy === 'FirstName'"
              [attr.aria-sort]="
                currentSort().sortBy === 'FirstName'
                  ? currentSort().sortDirection === 'asc'
                    ? 'ascending'
                    : 'descending'
                  : 'none'
              "
              tabindex="0"
              role="columnheader"
            >
              <span class="sortable">
                First Name
                <span class="sort-icons" aria-hidden="true">
                  <mat-icon>arrow_drop_up</mat-icon>
                  <mat-icon>arrow_drop_down</mat-icon>
                </span>
              </span>
            </th>
            <td mat-cell *matCellDef="let user">{{ user.firstName }}</td>
          </ng-container>

          <ng-container matColumnDef="lastName">
            <th
              mat-header-cell
              *matHeaderCellDef
              (click)="onSort('LastName')"
              (keydown.enter)="onSort('LastName')"
              (keydown.space)="$event.preventDefault(); onSort('LastName')"
              [class.active]="currentSort().sortBy === 'LastName'"
              [attr.aria-sort]="
                currentSort().sortBy === 'LastName'
                  ? currentSort().sortDirection === 'asc'
                    ? 'ascending'
                    : 'descending'
                  : 'none'
              "
              tabindex="0"
              role="columnheader"
            >
              <span class="sortable">
                Last Name
                <span class="sort-icons" aria-hidden="true">
                  <mat-icon>arrow_drop_up</mat-icon>
                  <mat-icon>arrow_drop_down</mat-icon>
                </span>
              </span>
            </th>
            <td mat-cell *matCellDef="let user">{{ user.lastName }}</td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th
              mat-header-cell
              *matHeaderCellDef
              (click)="onSort('Email')"
              (keydown.enter)="onSort('Email')"
              (keydown.space)="$event.preventDefault(); onSort('Email')"
              [class.active]="currentSort().sortBy === 'Email'"
              [attr.aria-sort]="
                currentSort().sortBy === 'Email'
                  ? currentSort().sortDirection === 'asc'
                    ? 'ascending'
                    : 'descending'
                  : 'none'
              "
              tabindex="0"
              role="columnheader"
            >
              <span class="sortable">
                Email
                <span class="sort-icons" aria-hidden="true">
                  <mat-icon>arrow_drop_up</mat-icon>
                  <mat-icon>arrow_drop_down</mat-icon>
                </span>
              </span>
            </th>
            <td mat-cell *matCellDef="let user">{{ user.email }}</td>
          </ng-container>

          <ng-container matColumnDef="organisation">
            <th
              mat-header-cell
              *matHeaderCellDef
              (click)="onSort('Organisation')"
              (keydown.enter)="onSort('Organisation')"
              (keydown.space)="$event.preventDefault(); onSort('Organisation')"
              [class.active]="currentSort().sortBy === 'Organisation'"
              [attr.aria-sort]="
                currentSort().sortBy === 'Organisation'
                  ? currentSort().sortDirection === 'asc'
                    ? 'ascending'
                    : 'descending'
                  : 'none'
              "
              tabindex="0"
              role="columnheader"
            >
              <span class="sortable">
                Organisation
                <span class="sort-icons" aria-hidden="true">
                  <mat-icon>arrow_drop_up</mat-icon>
                  <mat-icon>arrow_drop_down</mat-icon>
                </span>
              </span>
            </th>
            <td mat-cell *matCellDef="let user">
              {{ user.organisationName ?? "-" }}
            </td>
          </ng-container>

          <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef>Role</th>
            <td mat-cell *matCellDef="let user">
              {{ user.role | formatRole }}
            </td>
          </ng-container>

          <ng-container matColumnDef="laboratories">
            <th mat-header-cell *matHeaderCellDef>Laboratories</th>
            <td mat-cell *matCellDef="let user">{{ getLabNames(user) }}</td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let user">
              @if (user.userStatus != null) {
                <app-status-indicator
                  [status]="UserStatusPrimaryDisplay[user.userStatus]"
                  [matTooltip]="UserStatusSecondaryLabel[user.userStatus]"
                ></app-status-indicator>
              }
              @if (user.isLockedOut) {
                <span class="status-secondary status-secondary--locked"
                  >Account locked</span
                >
              }
              @if (user.isDisabled) {
                <span class="status-secondary status-secondary--disabled"
                  >Account disabled</span
                >
              }
              @if (user.twoFactorEnabled) {
                <span class="status-secondary status-secondary--two-factor"
                  >2FA enabled</span
                >
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let user">
              <div
                class="actions-cell"
                (click)="$event.stopPropagation()"
                (keydown.enter)="$event.stopPropagation()"
              >
                @if (user.userStatus === UserStatus.Active) {
                  <app-mat-icon-button
                    buttonId="edit-user-btn"
                    iconName="edit"
                    ariaLabel="Edit user"
                    (buttonClicked)="onEditUser(user.id)"
                  ></app-mat-icon-button>
                }
                @if (
                  user.userStatus === UserStatus.InviteSent ||
                  user.userStatus === UserStatus.InviteExpired
                ) {
                  <app-mat-icon-button
                    buttonId="resend-invite-btn"
                    iconName="forward_to_inbox"
                    ariaLabel="Resend invite"
                    [isDisabled]="resendInviteProcessing()"
                    (buttonClicked)="resendInvite(user.id)"
                  ></app-mat-icon-button>
                }
                @if (
                  user.userStatus === UserStatus.InviteSent ||
                  user.userStatus === UserStatus.InviteExpired
                ) {
                  <app-mat-icon-button
                    buttonId="delete-invite-btn"
                    iconName="delete"
                    ariaLabel="Delete invite"
                    buttonStyle="negative"
                    [isDisabled]="deleteInviteProcessing()"
                    (buttonClicked)="handleInviteDeletion(user.id)"
                  ></app-mat-icon-button>
                }
                @if (
                  user.userStatus === UserStatus.AwaitingConfirmation ||
                  user.userStatus === UserStatus.AwaitingConfirmationExpired
                ) {
                  <app-mat-icon-button
                    buttonId="resend-confirmation-btn"
                    iconName="forward_to_inbox"
                    ariaLabel="Resend confirmation email"
                    [isDisabled]="resendConfirmationEmailProcessing()"
                    (buttonClicked)="resendConfirmationEmail(user.id)"
                  ></app-mat-icon-button>
                }
                @if (
                  user.userStatus ===
                    UserStatus.PendingUpdateEmailConfirmation ||
                  user.userStatus ===
                    UserStatus.PendingUpdateEmailConfirmationExpired
                ) {
                  <app-mat-icon-button
                    buttonId="resend-update-confirmation-btn"
                    iconName="forward_to_inbox"
                    ariaLabel="Resend update email confirmation"
                    [isDisabled]="resendUpdateEmailConfirmationProcessing()"
                    (buttonClicked)="resendUpdateEmailConfirmation(user.id)"
                  ></app-mat-icon-button>
                }
                @if (
                  user.userStatus === UserStatus.AwaitingConfirmation ||
                  user.userStatus === UserStatus.AwaitingConfirmationExpired
                ) {
                  <app-mat-icon-button
                    buttonId="delete-user-btn"
                    iconName="delete"
                    ariaLabel="Delete user"
                    buttonStyle="negative"
                    [isDisabled]="deleteUserProcessing()"
                    (buttonClicked)="handleUserDeletion(user.id)"
                  ></app-mat-icon-button>
                }
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <tr *matNoDataRow>
            <td [attr.colspan]="displayedColumns.length" id="empty-state">
              <mat-icon id="empty-state--icon">person</mat-icon>
              <p id="empty-state--title">No users</p>
            </td>
          </tr>
        </table>
        @if (users().length > 0) {
          <div id="pagination--container">
            <div class="filter--container">
              <label for="users-per-page">Users per page</label>
              <app-dropdown-form-field
                id="users-per-page"
                [field]="usersPerPageField"
                [parentForm]="tableControls"
              ></app-dropdown-form-field>
            </div>
            <div id="pagination--controls">
              <app-icon-button
                iconName="chevron_left"
                buttonId="previous-btn"
                (buttonClicked)="getPrevious()"
                [isDisabled]="!hasPrevious()"
              ></app-icon-button>
              <span>{{ currentPage() }} / {{ totalPages() }}</span>
              <app-icon-button
                iconName="chevron_right"
                buttonId="next-btn"
                (buttonClicked)="getNext()"
                [isDisabled]="!hasNext()"
              ></app-icon-button>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
<app-filter-modal
  id="filter"
  primaryButtonText="Apply Filters"
  primaryButtonId="continue-button"
  secondaryButtonText="Reset"
  secondaryButtonId="reset-button"
  [modeField]="roleFilterField"
  [parentForm]="tableControls"
  [hideDeletedField]="true"
  (modalButtonClicked)="filterModalButtonClicked($event)"
></app-filter-modal>
<app-modal
  id="error"
  titleText="Error"
  [primaryText]="actionError()?.message"
  primaryButtonText="Close"
  primaryButtonId="close-button"
  modalStyle="error"
  (modalButtonClicked)="closeModal('error')"
></app-modal>
<app-validation-modal
  id="delete-invite"
  titleText="Delete Invite"
  validationText="delete"
  primaryButtonText="Delete Invite"
  primaryButtonId="delete-invite"
  secondaryButtonText="Close"
  secondaryButtonId="close-delete-invite"
  [isProcessing]="deleteInviteProcessing()"
  [error]="actionError()"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-validation-modal>
<app-validation-modal
  id="delete-user"
  titleText="Delete User"
  validationText="delete"
  primaryButtonText="Delete User"
  primaryButtonId="delete-user"
  secondaryButtonText="Close"
  secondaryButtonId="close-delete-user"
  [isProcessing]="deleteUserProcessing()"
  [error]="actionError()"
  (modalButtonClicked)="modalButtonClicked($event)"
></app-validation-modal>
